import { actions, paths } from "../../../../common/constants";

export default {
  getAdmins: () => ({
    [actions.CALL_API]: {
      types: [
        actions.GET_ADMINS_REQUEST,
        actions.GET_ADMINS_SUCCESS,
        actions.GET_ADMINS_FAILURE,
      ],
      promise: (client) => client.get(paths.api.v2.ADMINS),
    },
  }),
  getAdminSetting: () => ({
    [actions.CALL_API]: {
      types: [
        actions.GET_ADMIN_SETTING_REQUEST,
        actions.GET_ADMIN_SETTING_SUCCESS,
        actions.GET_ADMIN_SETTING_FAILURE,
      ],
      promise: (client) => client.get(paths.api.v1.ADMIN_SETTING),
    },
  }),
  updateAdminSetting: (adminData) => {
    const query = new FormData();
    for (let key in adminData) {
      if (adminData[key].length !== 0) query.append(key, adminData[key]);
    }

    return {
      [actions.CALL_API]: {
        types: [
          actions.SET_ADMIN_INFO_REQUEST,
          actions.SET_ADMIN_INFO_SUCCESS,
          actions.SET_ADMIN_INFO_FAILURE,
        ],
        promise: (client) =>
          client.put(paths.build(paths.api.v1.ADMIN_SETTING), query),
      },
    };
  },

  resetPassword: (credential) => ({
    [actions.CALL_API]: {
      types: [
        actions.ADMIN_RESET_PASSWORD_REQUEST,
        actions.ADMIN_RESET_PASSWORD_SUCCESS,
        actions.ADMIN_RESET_PASSWORD_FAILURE,
      ],
      promise: (client) =>
        client.post(paths.build(paths.api.v1.ADMIN_RESET_PASSWORD), credential),
    },
  }),
};



// WEBPACK FOOTER //
// ./client/react/Admin/actions/admin.js